var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.47483 13.2502L7.24983 17.0252C8.79983 18.5752 11.3165 18.5752 12.8748 17.0252L16.5332 13.3668C18.0832 11.8168 18.0832 9.30016 16.5332 7.74183L12.7498 3.97516C11.9582 3.1835 10.8665 2.7585 9.74983 2.81683L5.58316 3.01683C3.9165 3.09183 2.5915 4.41683 2.50816 6.07516L2.30816 10.2418C2.25816 11.3668 2.68316 12.4585 3.47483 13.2502Z",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91659 10.5002C9.06718 10.5002 9.99992 9.56742 9.99992 8.41683C9.99992 7.26624 9.06718 6.3335 7.91659 6.3335C6.76599 6.3335 5.83325 7.26624 5.83325 8.41683C5.83325 9.56742 6.76599 10.5002 7.91659 10.5002Z",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/tag-icon.fee31b3ae9b3e7b6d20d960810cbfbea.svg";
export { ForwardRef as ReactComponent };